import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../services/order/order.service";
import { OrderItemAttributes } from "@models/orderItem.model";
import { Location } from "@angular/common";
import { OrderStatus } from "@models/order.model";
import { finalize } from "rxjs";
import { ItemStatusHistoryModel } from "@models/itemStatusHistory.model";
import { ProductCategories } from '@models/product.model';
import { ColorsPicker } from '~/src/utils/color-constants';

export const OrderStatusOnly: string[] = ["Ordered", "Packed", "Cancelled", "Dispatched", "Delivered"];

export const ReturnOrderStatusOnly: string[] = ["Return Initiated", "Pickup Scheduled", "Returned"];

export const ExchangeOrderStatusOnly: string[] = [
    "Exchange Initiated",
    "Exchange Packed",
    "Exchange Dispatched",
    "Exchanged",
];

@Component({
    selector: "app-order-status",
    templateUrl: "./order-status.component.html",
    styleUrl: "./order-status.component.scss",
    standalone: false,
})
export class OrderStatusComponent implements OnInit {
    public orderId!: string;
    public itemId!: string;
    public orderItem!: OrderItemAttributes;
    public OrderStatus = OrderStatus;
    // public filteredOrderStatusHistory?: AdminStatusHistoryModel[]=[]
    public filteredOrderStatusHistory?: ItemStatusHistoryModel[] = [];
    public filteredReturnOrderStatusHistory?: ItemStatusHistoryModel[] = [];
    public filteredExchangeOrderStatusHistory?: ItemStatusHistoryModel[] = [];
    public showTimeline!: boolean;
    public isLoading: boolean = false;
    public categories = ProductCategories;
    public deliveryDate!: Date;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private orderService: OrderService,
        private location: Location,
    ) {}

    ngOnInit(): void {
        // To get the orderID & itemID from url
        this.route.params.subscribe((params) => {
            this.orderId = params["id"];
            this.itemId = this.route.snapshot.queryParamMap.get("itemId")!;
            if (this.orderId && this.itemId) {
                this.getOrderItemById();
            }
        });
    }

    public getOrderItemById(): void {
        this.isLoading = true;
        this.orderService
            .getOrderItemById(this.orderId, this.itemId)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe({
                next: (response: OrderItemAttributes) => {
                    if (response) {
                        this.orderItem = response;
                        if (this.orderItem?.createdAt) {
                            const orderDate = new Date(this.orderItem.createdAt);
                            this.deliveryDate = new Date(orderDate);
                            this.deliveryDate.setDate(orderDate.getDate() + 7);
                        }

                        // Connected timeline with scroll
                        // this.filteredOrderStatusHistory = this.orderItem.itemStatusHistory;

                        // To use separate timeline
                        this.filteredOrderStatusHistory = this.orderItem.itemStatusHistory!.filter((history) =>
                            OrderStatusOnly.includes(history.status),
                        );

                        this.filteredReturnOrderStatusHistory = this.orderItem.itemStatusHistory!.filter((history) =>
                            ReturnOrderStatusOnly.includes(history.status),
                        );
                        this.filteredExchangeOrderStatusHistory = this.orderItem.itemStatusHistory!.filter((history) =>
                            ExchangeOrderStatusOnly.includes(history.status),
                        );
                        this.showTimeline = this.filteredOrderStatusHistory.length > 0;
                    }
                },
            });
    }

    // Go to previous page
    public goBack(): void {
        if (window.history.length > 1) {
            this.location.back();
        } else {
            // No previous page — means open from notification
            this.router.navigate(["/home"]);
        }
    }

    public getFacesByType(data: OrderItemAttributes, type: string): string[] {
        const faceArray = [];
        for (const [key, value] of Object.entries(data.singleBlockInfoDirectBuy!)) {
            if (value === type) {
                faceArray.push(key);
            }
        }
        return faceArray;
    }

    /**** To get Color Name  ****/
    public getColorValue(color: string): string | undefined {
        return ColorsPicker.find((c) => c.name === color)?.value;
    }

    /**** To get Face Color  ****/
    public getFaceColors(colorObject: object | undefined): { key: string; value: string }[] {
        if (!colorObject) {
            return [];
        }
        return Object.entries(colorObject).map(([key, value]) => ({
            key,
            value: value as string, // Ensure the value is treated as a string
        }));
    }

    public navigateItemList(type: string): void {
        this.router.navigate([`/account/orders/${this.orderId}/${type}`]);
    }
}
